import { CompareChartCardPlugin } from './CompareChartCardPlugin';
import { DataTrackerChartCardPlugin } from './DataTrackerChartCardPlugin';
import { ImpactGaugeCardPlugin } from './ImpactGaugeCardPlugin';
import { ImpactProgressCardPlugin } from './ImpactProgressCardPlugin';
import { RollingAverageChartCardPlugin } from './RollingAverageChartCardPlugin';
import { StudyOverviewCardPlugin } from './StudyOverviewCardPlugin';
import { DataDiaryChartCardPlugin } from './DataDiaryChartCardPlugin';
import { DataDiaryCardPlugin } from './DataDiaryCardPlugin';
import { DownloadableFormsCardPlugin } from './DownloadableFormsCardPlugin';
import { ImageGalleryCardPlugin } from './ImageGalleryCardPlugin';
import { NotebookCardPlugin } from './NotebookCardPlugin';
import { CategoryHorizontalListPlugin } from './CategoryHorizontalListPlugin';
import { StudyListPlugin } from './StudyListPlugin';
import { WearableDataLineChartCardPlugin } from './WearableDataLineChartCardPlugin';
import { BloodGlucoseComparisonChartCardPlugin } from './BloodGlucoseComparisonChartCardPlugin';
import { BeforeAfterChartCardPlugin } from './BeforeAfterChartCardPlugin';
import { StudyTemplateListPlugin } from './StudyTemplateListPlugin';

export const defaultScreenComponentPlugins = [
  StudyOverviewCardPlugin,
  DataTrackerChartCardPlugin,
  RollingAverageChartCardPlugin,
  ImpactGaugeCardPlugin,
  ImpactProgressCardPlugin,
  CompareChartCardPlugin,
  DataDiaryChartCardPlugin,
  DataDiaryCardPlugin,
  CompareChartCardPlugin,
  DownloadableFormsCardPlugin,
  ImageGalleryCardPlugin,
  NotebookCardPlugin,
  WearableDataLineChartCardPlugin,
  BloodGlucoseComparisonChartCardPlugin,
  CategoryHorizontalListPlugin,
  StudyTemplateListPlugin,
  StudyListPlugin,
  BeforeAfterChartCardPlugin
];
